import React from 'react';
import { MessageSquare, Palette, Eye, Rocket } from 'lucide-react';
import { mockData } from '../../mock';

const iconMap = {
  'message-square': MessageSquare,
  'palette': Palette,
  'eye': Eye,
  'rocket': Rocket
};

const ProcessSection = () => {
  return (
    <section className="py-24 px-6 bg-[#111111]">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">How It Works</h2>
          <p className="text-[#9AA3B2] text-lg max-w-2xl mx-auto">
            Your new website in four simple steps
          </p>
        </div>
        
        <div className="grid md:grid-cols-4 gap-8 relative">
          {/* Connection line on desktop */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-0.5 bg-gradient-to-r from-[#2F6BFF]/20 via-[#4DA3FF]/40 to-[#2F6BFF]/20"></div>
          
          {mockData.process.map((step, index) => {
            const Icon = iconMap[step.icon];
            if (!Icon) {
              console.error(`Icon not found for: ${step.icon}`);
              return null;
            }
            return (
              <div key={step.id} className="relative">
                {/* Step card */}
                <div className="flex flex-col items-center text-center group">
                  {/* Number badge */}
                  <div className="relative mb-6">
                    <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#2F6BFF]/20 to-[#4DA3FF]/20 flex items-center justify-center border-2 border-[#2F6BFF]/30 group-hover:border-[#2F6BFF]/60 transition-all duration-300 relative z-10">
                      <Icon className="h-10 w-10 text-[#4DA3FF] group-hover:scale-110 transition-transform duration-300" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gradient-to-br from-[#2F6BFF] to-[#4DA3FF] flex items-center justify-center text-white font-bold text-sm shadow-lg">
                      {step.id}
                    </div>
                  </div>
                  
                  {/* Content */}
                  <h3 className="text-xl font-semibold text-white mb-3">{step.title}</h3>
                  <p className="text-[#9AA3B2] leading-relaxed">{step.description}</p>
                </div>
                
                {/* Arrow connector on mobile */}
                {index < mockData.process.length - 1 && (
                  <div className="md:hidden flex justify-center my-6">
                    <div className="w-px h-8 bg-gradient-to-b from-[#2F6BFF]/40 to-[#4DA3FF]/40"></div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
